import React from "react";
import { FaCalendar, FaClock } from "react-icons/fa";
import { prettifyRoute } from "../../../utils/routeUtil";
import { renderIcon } from "../../common/IconLibrary";

export const ROLE_COLORS = {
  admin: "#C0392B",
  "prompt-engineer": "#D35400",
  "clinical-author": "#27AE60",
  demonstrator: "#2980B9",
  viewer: "#8E44AD",
  requestor: "#F39C12",
  champion: "#16A085",
};

const UserCard = ({
  user,
  getActivityStatusColor,
  formatDuration,
  formatElapsed,
  compact = false,
}) => (
  <div className={`card-glass`}>
    <div className="flex items-center justify-between mb-2">
      <div className="flex items-center flex-1 min-w-0">
        <div
          className={`w-3 h-3 rounded-full flex-shrink-0 mr-2 ${getActivityStatusColor(
            user.lastActive
          )}`}
        ></div>
        <h3
          className={`${
            compact ? "text-sm" : "text-base"
          } font-semibold truncate max-w-[12rem] whitespace-nowrap overflow-hidden text-ellipsis`}
          title={user.userName}
        >
          {user.userName}
        </h3>
      </div>
      <div
        className={`flex-shrink-0 ${
          compact ? "text-xs" : "text-sm"
        } mt-0 text-gray-400`}
        title="Last active in the system"
      >
        {formatDuration(user.lastActive, compact ? "" : "ago", compact)}
      </div>
    </div>
    <div
      className={`flex justify-between items-center ${
        compact ? "mb-2" : "mb-3"
      } ${compact ? "text-xs" : "text-sm"}`}
    >
      <div className="flex items-center" title="First active in the system">
        <FaCalendar className="mr-1 text-blue-400" size={compact ? 10 : 12} />
        <span title={new Date(user.firstActive).toLocaleString()}>
          {formatDuration(user.firstActive, "", compact)}
        </span>
      </div>
      <div
        className="flex items-center"
        title="Time spent active in the system"
      >
        <FaClock className="mr-1 text-blue-400" size={compact ? 10 : 12} />
        <span>{formatElapsed(user.timeSpent, compact)}</span>
      </div>
    </div>
    <div className={`flex flex-wrap gap-1 ${compact ? "mt-1" : "mt-2 mb-3"}`}>
      {[...user.lastRoles] 
        .sort((a, b) => a.localeCompare(b)) 
        .map((role) => (
          <span
            key={role} 
            className={`px-1 py-0.5 rounded-md ${
              compact ? "text-[10px]" : "text-xs"
            } border text-gray-300`}
            style={{
              borderColor: ROLE_COLORS[role] || "gray",
              backgroundColor: ROLE_COLORS[role] + "1a" || "gray",
            }}
          >
            {role}
          </span>
        ))}
    </div>
    {!compact && (
      <div className="grid grid-cols-3 gap-0.5 text-xs text-gray-400 mt-2">
        {user.recents.slice(0, 10).map((route, index) => {
          const prettifiedRoute = prettifyRoute(route);
          if (!prettifiedRoute.icon) return null;
          return (
            <div key={index} className="flex items-center mb-1">
              {prettifiedRoute.icon ? (
                renderIcon(prettifiedRoute.icon, 16, 16)
              ) : (
                <div className="w-4 h-4 mr-1 flex-shrink-0" />
              )}
              <span className="truncate" title={prettifiedRoute.hint || route}>
                {prettifiedRoute.name}
              </span>
            </div>
          );
        })}
      </div>
    )}
  </div>
);

export default UserCard;
